<div class="link-page">
  <!-- Loading -->
  <div *ngIf="step === LinkStep.Loading" class="state-container">
    <div class="spinner"></div>

    <p>
      {{ "link.loading" | translate }}
    </p>
  </div>

  <!-- Error -->
  <div *ngIf="step === LinkStep.Error" class="state-container">
    <div class="state-icon error">
      <lucide-icon name="circle-alert" [size]="40"></lucide-icon>
    </div>

    <h1>
      {{ (linkExpired ? "link.error.expired.title" : "link.error.title") | translate }}
    </h1>

    <p>
      {{ (linkExpired ? "link.error.expired.description" : "link.error.description") | translate }}
    </p>
  </div>
</div>
